import React, { useEffect, useState } from "react";

const HeroSection = ({ buttonLink }) => {
    const [animate, setAnimate] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        setTimeout(() => setAnimate(true), 200);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = ` 
            /* your keyframes and animations here */
            /* (keeping your code) */
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div
            className="hero-section"
            style={{
                backgroundPositionY: "21%",
                position: "relative",
                backgroundImage: `url(/assets/img/theme/${isMobile ? 'hero-bg0.jpg' : 'hero-bg0.jpg'})`,
            }}
        >
            <div className="container mx-auto relative z-10">
                <div className="hero-content">
                    <h1 className={`hero-title ${animate ? "fade-in-left" : ""}`}>
                        Simplifiez vos procédures administratives en France avec nos avocats partenaire
                    </h1>
                    <div className={`flex items-center flex-wrap gap-1 z-50 mt-5 ${animate ? "fade-in-left delay-2" : ""}`}>
                        <a
                            href={buttonLink}
                            className={`banner-btn text-white font-medium transition-all hover:shadow-lg heartbeat-animation rounded-full
                              ${isMobile ? 'px-4 py-2 text-center' : 'px-8 py-3'} button-red`}
                        >
                            {isMobile ? (
                                <>
                                    <div>Lancez vos procédures</div>
                                    <div>Consultation 100% Gratuite</div>
                                </>
                            ) : (
                                "Lancez vos procédures - Consultation 100% Gratuite"
                            )}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;